<template>

	<transition name="fade">

		<div class="global-nav__overlay" v-if="show">

			<slot></slot>

		</div>

	</transition>

</template>

<script>
    export default {
        data: function () {
            return {}
        },
        props:['show'],
        methods: {
            close(){
                this.$emit('close', true);
            },

        },
    }
</script>
